import type { ReactElement } from "react";
import { Datagrid, FunctionField, TextField, useListContext } from "react-admin";
import { useMediaQuery } from "@mui/material";
import type { Theme } from "@mui/material";
import { useNavigate } from "react-router";
import { Column } from "../../misc/Column";
import { LoadingIndicator } from "../../misc/LoadingIndicator";
import type { CourseTemplate } from "../../providers/courseTemplatesProvider";
import { CourseTemplateMobileListItem } from "./CourseTemplateMobileListItem";

export function CourseTemplatesDataGrid(props: { empty?: ReactElement }) {
  const { empty } = props;
  const { isLoading, data, total } = useListContext<CourseTemplate>();
  const navigate = useNavigate();
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));

  if (isLoading) {
    return <LoadingIndicator />;
  }

  if (isMobile) {
    if (!data || data.length === 0 || total === 0) {
      return empty ?? null;
    }

    return (
      <Column sx={{ gap: 1, py: "1px" }}>
        {data.map((courseTemplate) => (
          <CourseTemplateMobileListItem
            key={courseTemplate.id}
            courseTemplate={courseTemplate}
            onClick={() => navigate(`/courseTemplates/${courseTemplate.id}`)}
          />
        ))}
      </Column>
    );
  }

  return (
    <Datagrid rowClick="edit" bulkActionButtons={false} empty={empty}>
      <TextField label="Name" source="name" />
      <FunctionField label="Kursteile" render={renderModules} sortable={false} />
    </Datagrid>
  );
}

function renderModules(courseTemplate: CourseTemplate) {
  const moduleNames = courseTemplate.modules.slice(0, 3).map((module) => module.name);
  return `${moduleNames.join(", ")}${courseTemplate.modules.length > 3 ? ", ..." : ""}`;
}
